import { render } from "./TracePic.vue?vue&type=template&id=8ccff9c8&scoped=true&ts=true"
import script from "./TracePic.vue?vue&type=script&lang=ts"
export * from "./TracePic.vue?vue&type=script&lang=ts"

import "./TracePic.vue?vue&type=style&index=0&id=8ccff9c8&lang=less&scoped=true"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccff9c8"]])

export default __exports__